
<div class="se-timeline-container">
    <!-- TIMELINE CLINICAL HISTORY -->
    @if(lastTimelineMode()) {

    @if(lastTimelineMode() === 'clinical') {
    @if(!!groupedClinicalHistoryData.length && !!clinicalHistory.length) {
    <div class="se-timeline-inner-container"
         [ngClass]="{'is-single-year': groupedClinicalHistoryDataClone.length === 1}">
        @if(groupedClinicalHistoryDataClone.length > 0) {
        <se-timeline-details class="timeline-details-main-container" [futureVisits]="futureVisits"
                             [formType]="formType" [mode]="'clinical'">
        </se-timeline-details>
        } @else {
        <ng-template>
            <span class="no-result">{{"NoResults" | translate}}</span>
        </ng-template>
        }

        <div class="info-icon is-past">
            @if(showInfo.past) {
            <mat-icon class="icon-past" [matTooltip]="'PreviuosVisitsToShow'| translate" matTooltipPosition="below">info</mat-icon>
            }
        </div>
        <div class="info-icon is-future">
            @if(showInfo.future) {
            <mat-icon class="icon-future" [matTooltip]="'FutureVisitsToShow'| translate" matTooltipPosition="below">info</mat-icon>
            }
        </div>

        @if(!!clinicalHistory.length) {
        <se-timeline-filters class='se-timeline-filters'
                             [data]="groupedClinicalHistoryData"
                             [mode]="'clinical'"
                             (showInfo)="_toggleShowInfo($event)"
                             (filtersChange)="_onFiltersChange($event)">
        </se-timeline-filters>
        }
    </div>
    }

    @if(isLoading | async) {
    <div class="timeline-spinner estensa-spinner"
         [ngClass]="{'timeline-spinner-no-data': !clinicalHistory.length}">
        <mat-spinner></mat-spinner>
    </div>
    }
    @if(!clinicalHistory.length) {
    <div class="se-timeline-text-container">
        <span>{{timelineMessage}}</span>
    </div>
    }
    @if(!!clinicalHistory.length && futureVisits.length !== 0 && groupedClinicalHistoryData.length == 0) {
    <div class="se-timeline-text-container">
        <span>{{"TimelineFutureVisits" | translate}}</span>
    </div>
    }
    }

    <!-- TIMELINE REPORT HISTORY -->
    @else if(lastTimelineMode() === 'report') {
    @if(!!groupedReportHistoryData.length) {
    <div class="se-timeline-inner-container"
         [ngClass]="{'is-single-year': groupedReportHistoryDataClone.length === 1}">

        @if(groupedReportHistoryDataClone.length > 0) {
        <se-timeline-details class="timeline-details-main-container"
                             [futureVisits]="[]"
                             [formType]="formType"
                             [mode]="'report'">
        </se-timeline-details>
        } @else {
        <ng-template>
            <span class="no-result">{{ "NoResults" | translate }}</span>
        </ng-template>
        }
        <div class="info-icon is-past">
            @if(showInfo.past) {
            <mat-icon class="icon-past"
                      [matTooltip]="'PreviuosVisitsToShow' | translate"
                      matTooltipPosition="below">info</mat-icon>
            }
        </div>
        <div class="info-icon is-future">
            @if(showInfo.future) {
            <mat-icon class="icon-future"
                      [matTooltip]="'FutureVisitsToShow' | translate"
                      matTooltipPosition="below">info</mat-icon>
            }
        </div>

        @if(!!groupedReportHistoryData.length) {
        <se-timeline-filters class="se-timeline-filters"
                             [data]="groupedReportHistoryData"
                             [mode]="'report'"
                             (showInfo)="_toggleShowInfo($event)"
                             (filtersChange)="_onFiltersChange($event)">
        </se-timeline-filters>
        }

    </div>
    }

    @if(isLoading | async) {
    <div class="timeline-spinner estensa-spinner report-history-spinner"
         [ngClass]="{'timeline-spinner-no-data': !groupedReportHistoryData.length}">
        <mat-spinner></mat-spinner>
        <span>{{'Loading' | translate}}</span>
    </div>
    } @else if(!(isLoading | async) && !groupedReportHistoryData.length) {
    <div class="se-timeline-text-container">
        <span>{{'TimelineReportHistoryNoResults' | translate}}</span>
    </div>
    }

    }
    }
</div>




